import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter021() {
  return <KbChapterPage slug="chapter-021" />;
}

(Chapter021 as unknown as { path: string }).path = "/theory-album/021";
